import React, { useCallback, useEffect } from 'react'
import styled from 'styled-components'

import Flex from 'components/reusable/flex'
import Indent from 'components/reusable/indent'
import { BodyMain, H4 } from 'components/views/help/help_faq_v2/components/styled'
import Button from 'components/reusable/button'
import SvgCrossMarkSolid from 'components/reusable/svg/svg_cross_mark_solid'
import InitHelper from 'helpers/init_helper'
import { LocalStorage } from 'classes/sc_localstorage'
import SvgBellOutline from 'components/reusable/svg/svg_bell_outline'
import { colors } from 'helpers/colors'

const Wrapper = styled(Flex)`
  max-width: 480px;
  width: 100%;
  padding: 56px;
  position: relative;
  @media (max-width: 768px) {
    padding: 24px 16px 16px;
  }
`

const StyledButton = styled(Button)`
  position: absolute;
  top: 30px;
  right: 40px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
`

const IconWrapper = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 24px;
  background-color: ${colors.primary[50]};
  display: flex;
  align-items: center;
  justify-content: center;
`

const RequestNotificationPermissionsModal = ({ onClose }) => {
  const handleSubscribeNotifications = useCallback(() => {
    InitHelper.webPushInit(true)
    onClose()
  }, [onClose])

  const handlePostponeRequest = useCallback(() => {
    const today = new Date()
    const remindDate = new Date(today)

    if (process.env.NODE_ENV === 'development') {
      remindDate.setMinutes(today.getMinutes() + 1)
    } else {
      remindDate.setDate(today.getDate() + 1)
    }
    LocalStorage.setPushPermissionsRemindAt(remindDate)
    onClose()
  }, [onClose])

  useEffect(() => {
    LocalStorage.setPushPermissionsAskedAt()
    LocalStorage.removePushPermissionsRemindAt() // or reschedule it in long term
  }, [])

  return (
    <Wrapper dir="column" wrap="nowrap">
      <StyledButton type="semantic-wrapper" onClick={onClose} aria-label="Close">
        <SvgCrossMarkSolid size={20} />
      </StyledButton>

      <IconWrapper>
        <SvgBellOutline color={colors.primary[500]} size={24} />
      </IconWrapper>

      <Indent bottom={4} />
      <H4>Stay updated!</H4>
      <Indent bottom={18} />

      <BodyMain textAlign="center">
        Notifications are currently off. Enable notifications and never miss important alerts about jobs, messages and
        key events.
      </BodyMain>
      <Indent bottom={24} />

      <Button type="primary" height={40} width="100%" onClick={handleSubscribeNotifications}>
        Allow Notifications
      </Button>

      <Indent bottom={12} />

      <Button type="gray-shadow" height={40} width="100%" onClick={handlePostponeRequest}>
        Maybe later
      </Button>
    </Wrapper>
  )
}

export default RequestNotificationPermissionsModal
